<template>
  <CCard class="question__card">
    <CCardHeader> افزودن سؤال</CCardHeader>
    <CCardBody class="d-flex align-items-start h-100">
      <CForm class="w-100">
        <CTextarea v-model="form.text" class="text-sm" label="صورت سؤال"/>

        <div class="d-flex flex-column justify-content-center">
          گزینه ها:
          <div
              v-for="index in 6"
              :key="index"
              class="mt-3 d-flex align-items-center"
          >
            {{ index }}.
            <CInput
                v-model="choices[index - 1]"
                :disabled="choices[index - 2] === ''"
                class="text-sm flex-fill mr-2 mb-0"
                placeholder="عنوان گزینه"
            />
          </div>
        </div>
      </CForm>
    </CCardBody>

    <CCardFooter>
      <CButton class="px-sm-5 py-sm-2" color="primary" @click="addQuestion">
        ثبت سوال
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  data() {
    return {
      form: {
        text: "",
        choices: this.choices,
      },
      loading: false,
      choices: ["", "", "", "", "", ""],
    };
  },
  watch: {
    choices() {
      try {
        let flag = false;
        for (let index = 0; index < 6; index++) {
          if (this.choices[index] === "") flag = true;
          else if (flag) this.choices[index] = "";
        }
      } catch (error) {
        console.log("errrrrror", error);
      }
    },
  },
  methods: {
    async addQuestion() {
      try {
        this.loading = true;
        this.form.choices = this.choices;
        const {id: pollId} = this.$route.params;
        const payload = {
          text: this.form.text,
          choices: this.form.choices,
        };
        await axios.post(`/survey/${pollId}/question`, payload);
        this.choices = ["", "", "", "", "", ""];
        this.form = {}
        this.$router.push(`/manager/poll/${pollId}`)
        this.getQuestions();
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>